import { usePTeamStore } from '@/store';
import { computed } from 'vue';
import { postGeneralEvent } from './client-dw-collect';
import { checkWpsEnvIsNewPage } from './env';
import { getDwLoaded } from './load-js-to-dom';
import { getSrc, isSupportWpsFnAsync } from './wps-fn';
export const dwInit = () => {
  getDwLoaded(() => {
    const { dw } = window;
    if (dw) {
      dw.setAppKey('d2c1a458c5aa631b');

      // 设置调试模式
      const isDwDebug = import.meta.env.MODE === 'production' ? false : true;
      dw.setDebug(isDwDebug);

      let version = '1.0.0';
      let channel = '1.0.0';
      const fn = window.common?.wpsClientApi?.getAppInfo;
      if (fn) {
        fn((res) => {
          version = res?.version || '1.0.0';
          channel = res?.channel || '1.0.0';

          dw.setVersion(version);
          dw.setChannel(channel);
        });
      } else {
        dw.setVersion(version);
        dw.setChannel(channel);
      }
    }
  });
};

/**
 * 设置 dw account id
 * @param id
 * @returns
 */
export const setDwAccountId = (id?: number) => {
  return getDwLoaded(() => {
    window.dw.setAccountId(id);
  });
};

export const dwCollect = async (params: Record<string, any>) => {
  // _open_platform_appid、_account_id、_device_id、_channel、_app_version

  // 每个埋点都默认需上报:_open_platform_appid、_account_id、_device_id、_channel、_app_version、comp_id、_group_members、_trail_process（定义参见 《轻流-公共上报》）

  /** 新购  新用户 || 权益过期 */

  const { statics } = usePTeamStore();
  const isNewPay = computed(() => {
    if (statics && (statics.team_rights?.member_id === 0 || statics.team_rights?.is_end_time_expired)) {
      return true;
    }
    return false;
  });

  const _open_platform_appid = 'wps_app';
  let src = 'wps_app';

  // 判断新建页是否支持获取src
  if (checkWpsEnvIsNewPage()) {
    // 从客户端获取src
    src = await getWpsSrcAsync();
  }

  const group_id = statics?.curr_team_info?.team_id || '';
  const group_members = statics?.team_users?.member_enable_num || '';
  let trail_process = 'unknown' as string | number;
  if (statics) {
    trail_process = isNewPay.value ? getDays(usePTeamStore().statics?.team_rights?.create_time + '000') : 'paid';
  }

  // 区分正式和测试环境的埋点
  const key3 = import.meta.env.MODE === 'production' ? 'formal' : 'test';

  const dwParams = {
    _open_platform_appid,
    open_platform_appid: _open_platform_appid,
    src,
    // 当前工作区id
    _group_id: group_id,
    // 当前工作区id
    group_id: group_id,
    // 当前所在工作区的启用人数
    _group_members: group_members,
    // 当前所在工作区的启用人数
    group_members: group_members,
    // 当前所处的工作区试用天数
    // 1.当天创建的工作区上报0，昨天创建的工作区上报1……以此类推
    // 2.若当前工作区已付费，则上报paid；
    _trail_process: trail_process,
    // 当前所处的工作区试用天数
    // 1.当天创建的工作区上报0，昨天创建的工作区上报1……以此类推
    // 2.若当前工作区已付费，则上报paid；
    trail_process: trail_process,
    key3,
    ...params,
  };
  // wps客户端上报
  postGeneralEvent('newapp_dbp', dwParams);
  // 浏览器端上报
  getDwLoaded(() => {
    window.dw.onEvent('app_dbp', dwParams);
  });
};

/**
 * 获取当前时间和工作区创建时间差
 */
function getDays(startDate: string) {
  const sDate = Number(startDate);
  const eDate = new Date().getTime();
  if (sDate > eDate) {
    return 0;
  }
  if (sDate === eDate) {
    return 1;
  }
  const days = (eDate - sDate) / (1 * 24 * 60 * 60 * 1000);
  return Math.floor(days);
}

/** 缓存当前的客户端src值 */
const wpsSrc = '';
/**
 * 获取客户端src值
 *
 * 从桌面快捷方式获取
 */
function getWpsSrcAsync() {
  return (
    wpsSrc ||
    new Promise<string>((res, rej) => {
      // 回调
      const cb = (data: string) => {
        try {
          const dataObj = JSON.parse(data);
          const { callstatus, result, src } = dataObj || {};
          if (callstatus === 'ok' && result === 'ok') {
            // 判断执行成功
            return res(src);
          }
          // 执行失败
          return res('');
        } catch (err) {
          res('');
        }
      };

      // 调用wps客户端方法获取src
      getSrc(cb);
    })
  );
}
